import { FacilitiesReducer, roomFacilitiesReducer, extraFacilitiesReducer } from './reducer';
import { combineReducers } from '@ngrx/store';
import { ActionReducer } from 'ngx-bootstrap/mini-ngrx';

export const reducers = {
    facilities: FacilitiesReducer,
    roomFacilities: roomFacilitiesReducer,
    optionalCategories: extraFacilitiesReducer
  };

  const reducer: ActionReducer<any> = combineReducers(reducers);
